// Whitelist of event urlPaths
const events = [
  'test-ride'
].join('|');

const PATHS = {
  US_BASE: '/us',
  CN_BASE: '/cn',
  MY_FF: '/MyFF',
  // Account info page
  ACCOUNT: '/account',
  MY_ACCOUNT: '/MyFF/account',
  MY_RESERVATIONS: '/MyFF/reservations',
  MY_EVENTS: '/MyFF/events',
  MY_REFERRALS: '/MyFF/referrals',
  MY_FF_POINTS: '/MyFF/points',
  MY_DESIGNS: '/MyFF/designs',
  // Login / sign up page
  LOGIN: '/account/login',
  // Welcome, successful login
  SUCCESS: '/account/success',
  // Forgot password page
  FORGOT_PASS: '/account/forgot-password',
  // Reset password page
  RESET_PASS: '/account/reset-password/:key',

  // Reserve
  RESERVE: '/reserve',
  // Reservation detailed view
  RESERVE_DETAILS: '/reserve/details/:confNum',
  RESERVE_DETAILS_BASE: '/reserve/details',
  ORDER_DETAILS: '/reserve/orders/:confNum',
  ORDER_DETAILS_BASE: '/reserve/orders',
  DESIGN_DETAILS: '/design/details/:confNum',
  DESIGN_DETAILS_BASE: '/design/details/',
  // My Referrals
  REFERRAL: '/referral/:referralCode',
  DESIGN: '/design',
  CONFIGURATOR: '/configurator',

  // Events
  BASE_EVENT: '/event',
  // Routes include whitelist; Others are for navigation (history.push())
  LANDING_EVENT_ROUTE: `/event/:eventName(${events})`,
  SCHEDULE_EVENT_ROUTE: `/event/:eventName(${events})/schedule`,
  CONFIRM_EVENT_ROUTE: `/event/:eventName(${events})/confirm`,
  RESCHEDULE_EVENT_ROUTE: `/event/:eventName(${events})/reschedule`,
  LANDING_EVENT: '/event/:eventName',
  SCHEDULE_EVENT: '/event/:eventName/schedule',
  CONFIRM_EVENT: '/event/:eventName/confirm',
  RESCHEDULE_EVENT: '/event/:eventName/reschedule',

  FF91_PRODUCT_PAGE: '/ff-91/',

  toCN: '/cn/MyFF',
  toUS: '/us/MyFF',
  PRIVACY: '/privacy-policy',
  TERMS_OF_USE: '/terms-of-use',
  REZ_AGREEMENT: '/us/reservation-agreement',
  PREORDER_AGREEMENT: '/preorder-agreement',
  MAIL_PRODUCT: 'mailto:product@ff.com',

  VERIFY_EMAIL: '/verify-email/:email',

  // FF 91 New Configurator
  FF91_DESIGN_PREFIX: '/design/2022/FF91'
};

export default PATHS;
